<template>
  <div class="pre-interview-container">
    <!-- Loading Overlay Customizado -->
    <div v-if="isLoadingVacancyData" class="custom-loading-overlay">
      <div class="spinner-large"></div>
    </div>

    <nav class="navbar-pre-interview" v-if="vacancyData.company">
      <img :src="vacancyData.company.logo" alt="Logo da empresa" />
    </nav>

    <div v-if="step === 1" class="welcome-section">
      <div class="welcome-texts">
        <h3>
          Olá, sou a Rê a IA da Recrutei, e vou conduzir essa pré-entrevista
          para a vaga
          <strong :style="{ color: vacancyData.company.base_hexcolor }">
            {{ vacancyData.vacancy.title || "Não informada" }}
          </strong>
        </h3>

        <span>
          Vou fazer algumas perguntas relacionadas ao seu conhecimento para este
          cargo, você poderá responder em texto ou audio
        </span>
      </div>

      <button
        :style="{
          '--company-color': vacancyData.company.base_hexcolor || '#ccc',
        }"
        @click="setAccess"
        :disabled="isLoadingSetAccess"
      >
        <template v-if="!isLoadingSetAccess"> Começar </template>

        <template v-else>
          <span class="spinner"></span>
        </template>
      </button>
    </div>

    <div v-if="step === 2" class="chat-section">
      <div
        class="chat"
        ref="chatContainer"
        :style="{ paddingBottom: !showInput ? '24px' : '120px' }"
      >
        <div
          class="message"
          v-for="(message, index) in messages"
          :key="message.created_at"
          :class="{ 'message-new': isNewMessage(index) }"
          :style="{
            justifyContent: message.from === 'user' ? 'flex-end' : 'flex-start',
          }"
        >
          <div class="re-indicator" v-if="message.from !== 'user'">
            <img src="~@/assets/images/re_seria_2.png" alt="Rê IA" />
          </div>

          <div
            class="message-bubble"
            :style="{
              backgroundColor: message.from === 'user' ? '#2E2E2E' : '#F6F6F6',
              borderRadius:
                message.from === 'user'
                  ? '25px 25px 0 25px'
                  : '25px 25px 25px 0',
              color: message.from === 'user' ? '#fff' : '#696969',
            }"
            v-html="message.value.trim().replace(/\n/g, '<br>')"
          ></div>

          <button
            v-if="message.from === 'user' && message.hasError"
            class="retry-button"
            @click="retryMessage(message)"
            :disabled="isLoadingConversation"
            :style="{ color: vacancyData.company.base_hexcolor }"
            title="Reenviar mensagem"
          >
            <i class="material-icons">refresh</i>
          </button>
        </div>

        <div
          class="message-loading"
          v-if="isLoadingConversation"
        >
          <div class="re-indicator">
            <img src="~@/assets/images/re_seria_2.png" alt="Rê IA" />
          </div>

          <div class="typing-indicator">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        <button
          v-if="showFinishInterviewButton"
          class="end-interview-button"
          @click="finishInterview"
          :disabled="isLoadingFinishInterview"
          :style="{
            '--company-color': vacancyData.company.base_hexcolor || '#ccc',
          }"
        >
          <template v-if="!isLoadingFinishInterview">
            Finalizar pré-entrevista
          </template>

          <template v-else>
            <span class="spinner"></span>
          </template>
        </button>
      </div>

      <div v-if="showInput" class="chat-footer">
        <div
          class="wrapper-input"
          :style="{
            borderColor: inputIsFocused
              ? vacancyData.company.base_hexcolor
              : '#d4d4d4',
          }"
        >
          <textarea
            ref="textareaRef"
            v-model="message"
            @focus="inputIsFocused = true"
            @blur="inputIsFocused = false"
            @keydown="handleKeyDown"
            placeholder="Escreva sua resposta"
            rows="1"
          />
          <button
            class="icon-button"
            :style="{ color: vacancyData.company.base_hexcolor }"
            @click="handleSubmit"
          >
            <i class="material-icons">send</i>
          </button>
        </div>
      </div>
    </div>

    <div v-if="step === 3" class="end-section">
      <div class="end-texts">
        <h3>
          Parabéns, você concluiu a pré-entrevista para a vaga de
          {{ vacancyData.vacancy.title || "Não informada" }}!
        </h3>
        <span>
          Você será comunicado(a) sobre o processo seletivo via e-mail o mais
          breve possível. Boa sorte!
        </span>
      </div>

      <button
        :style="{
          '--company-color': vacancyData.company.base_hexcolor || '#ccc',
        }"
        @click="returnToVacancies"
      >
        Fechar
      </button>
    </div>
  </div>
</template>

<script>
import confetti from 'canvas-confetti';

export default {
  data() {
    return {
      // General
      step: 1,
      sessionId: null,

      // Step 1
      vacancyData: {
        company: {
          logo: "",
          base_hexcolor: "#1551b1",
        },
      },
      isLoadingVacancyData: false,
      isLoadingSetAccess: false,

      // Step 2
      message: "",
      messages: [],
      initialMessageCount: 0,
      isLoadingConversation: false,
      showFinishInterviewButton: false,
      isLoadingFinishInterview: false,
      showInput: true,
      inputIsFocused: false,
    };
  },
  computed: {
    vacancyId() {
      return this.$route.params.vacancyId;
    },
  },
  methods: {
    nextStep() {
      this.step++;
    },

    isNewMessage(index) {
      return index >= this.initialMessageCount;
    },

    adjustTextareaHeight() {
      const textarea = this.$refs.textareaRef;
      if (!textarea) return;

      textarea.style.height = "auto";

      if (textarea.scrollHeight > 200) {
        textarea.style.height = "200px";
        textarea.style.overflowY = "auto";
      } else {
        textarea.style.height = `${textarea.scrollHeight}px`;
        textarea.style.overflowY = "hidden";
      }
    },

    handleKeyDown(e) {
      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault();
        this.handleSubmit();
      }
    },

    scrollToBottom() {
      const el = this.$refs.chatContainer;
      if (el) {
        this.$nextTick(() => {
          setTimeout(() => {
            el.scrollTo({
              top: el.scrollHeight,
              behavior: "smooth",
            });
          }, 100);
        });
      }
    },

    async finishInterview() {
      this.isLoadingFinishInterview = true;
      try {
        await this.$http.put(
          `/api/v1/turbo/pre-interview/internal/${this.sessionId}/finish`
        );
        this.nextStep();
      } catch (error) {
        console.error("Erro ao finalizar interview:", error);
      } finally {
        this.isLoadingFinishInterview = false;
      }
    },

    async retryMessage(messageToRetry) {
      const messageIndex = this.messages.findIndex(
        (m) => m.created_at === messageToRetry.created_at
      );

      if (messageIndex !== -1) {
        this.$set(this.messages[messageIndex], "hasError", false);
      }

      this.isLoadingConversation = true;
      this.$nextTick(() => this.scrollToBottom());

      try {
        const response = await this.$http.post(
          `/api/v1/turbo/pre-interview/internal/${this.sessionId}/conversation`,
          {
            answer: messageToRetry.value,
          }
        );

        this.messages.push({
          created_at: new Date().toISOString(),
          from: "assistant",
          ...response.data.data.next,
        });

        const data = response && response.data && response.data.data;
        const next = data && data.next;

        if (next && next.finished) {
          this.showInput = false;
          this.showFinishInterviewButton = true;
        }
        this.$nextTick(() => this.scrollToBottom());
      } catch (error) {
        console.error("Erro ao reenviar resposta:", error);
        if (messageIndex !== -1) {
          this.$set(this.messages[messageIndex], "hasError", true);
        }
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possível reenviar a resposta",
          color: "error",
        });
      } finally {
        this.isLoadingConversation = false;
      }
    },

    async handleSubmit() {
      if (!this.message.trim()) return;
      const lastQuestion = this.messages
        .slice()
        .reverse()
        .find((msg) => msg.from === "assistant" && msg.question_id);

      const questionId = lastQuestion ? lastQuestion.question_id : null;
      const userMessage = {
        created_at: new Date().toISOString(),
        from: "user",
        value: this.message,
        question_id: questionId,
        hasError: false,
      };

      this.messages.push(userMessage);
      this.$nextTick(() => this.scrollToBottom());
      const sendMessage = this.message;
      this.message = "";
      this.$nextTick(() => this.adjustTextareaHeight());
      this.isLoadingConversation = true;

      try {
        const response = await this.$http.post(
          `/api/v1/turbo/pre-interview/internal/${this.sessionId}/conversation`,
          {
            answer: sendMessage,
          }
        );

        this.messages.push({
          created_at: new Date().toISOString(),
          from: "assistant",
          ...response.data.data.next,
        });

        const data = response && response.data && response.data.data;
        const next = data && data.next;

        if (next && next.finished) {
          this.showInput = false;
          this.showFinishInterviewButton = true;
        }
        this.$nextTick(() => this.scrollToBottom());
      } catch (error) {
        console.error("Erro ao enviar resposta:", error);
        const messageIndex = this.messages.findIndex(
          (m) => m.created_at === userMessage.created_at
        );
        if (messageIndex !== -1) {
          this.$set(this.messages[messageIndex], "hasError", true);
        }
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possível enviar a resposta",
          color: "error",
        });
      } finally {
        this.isLoadingConversation = false;
      }
    },

    returnToVacancies() {
      this.$router.back();
    },

    async fetchVacancyData() {
      if (!this.vacancyId) return;

      this.isLoadingVacancyData = true;

      try {
        const response = await this.$http.get(
          `/api/v1/turbo/pre-interview/internal/${this.vacancyId}/data`
        );

        this.vacancyData = response.data.data;
      } catch (error) {
        console.error("Erro ao buscar pré-entrevista:", error);
      } finally {
        this.isLoadingVacancyData = false;
      }
    },

    async setAccess() {
      if (!this.vacancyId) return;
      this.isLoadingSetAccess = true;
      try {
        const response = await this.$http.post(
          `/api/v1/turbo/pre-interview/internal/${this.vacancyId}/access`
        );
        const isEnabledToFinishInterview = response.data.data.enabled_to_finish;

        this.messages = response.data.data.answers;
        this.initialMessageCount = this.messages.length;
        this.sessionId = response.data.data.session_id;
        this.nextStep();
        this.$nextTick(() => this.scrollToBottom());
        if (isEnabledToFinishInterview) {
          this.showFinishInterviewButton = true;
          this.showInput = false;
        }
      } catch (error) {
        console.error("Erro ao acessar pré-entrevista:", error);
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possível acessar a pré-entrevista",
          color: "error",
        });
      } finally {
        this.isLoadingSetAccess = false;
      }
    },

    startConfettiEffect() {
      var count = 200;
      var defaults = {
        origin: { y: 0.4 }
      };
      const colors = [
        "#0857A0",
        "#3889D6",
      ]

      const shapes = [
        "star",
        "square",
        "circle",
      ]

      function fire(particleRatio, opts) {
        confetti({
          ...defaults,
          ...opts,
          particleCount: Math.floor(count * particleRatio),
          colors,
          shapes,
        });
      }

      fire(0.25, {
        spread: 26,
        startVelocity: 55,
      });
      fire(0.2, {
        spread: 60,
      });
      fire(0.35, {
        spread: 100,
        decay: 0.91,
        scalar: 0.8,
      });
      fire(0.1, {
        spread: 120,
        startVelocity: 25,
        decay: 0.92,
        scalar: 1.2,
      });
      fire(0.1, {
        spread: 120,
        startVelocity: 45,
      });
    },
  },

  watch: {
    step(newStep) {
    if (newStep === 3) {
      this.startConfettiEffect();
    }
  },
    message() {
      this.$nextTick(() => this.adjustTextareaHeight());
    },
    vacancy: {
      handler() {
        this.fetchVacancyData();
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/talent/components/preinterview.scss";

/* Estilos adicionais para o botão de retry */
.retry-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border-radius: 50%;
  border: none;
  background-color: transparent;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
  padding: 0;

  &:hover:not(:disabled) {
    background-color: rgba(233, 233, 233, 0.651);
    transform: rotate(180deg);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  i {
    font-size: 20px;
  }
}
</style>
